module.exports = __webpack_public_path__ + "img/feedback_danger_manual.32c2d612.svg";